import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UtilitarioService } from './utilitario.service';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AtividadeService {

  constructor(private globalService: GlobalService, private http: HttpClient, private utilitarioService: UtilitarioService) {

  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idIntegrador) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (idIntegrador !== undefined && idIntegrador !== null) {
      parametros = parametros.set('idIntegrador', idIntegrador);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Atividade/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Atividade/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(vm) {
    return this.http.post(globals.apiUrl + '/api/Atividade/Salvar', vm);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Atividade/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
